<div class="page-container gap-24 font-color-black">
  <div class="page-title">
    Allgemeine Geschäftsbedingungen der Fortbildungsplattform „Institut Wissen“
  </div>
  <div class="flex-c gap-24">
    <span class="title-level-2">
      1. Geltungsbereich, Begriffsbestimmungen
    </span>
    <div class="flex-r gap-8">
      <span class="title-level-3"> 1.1. </span>
      <div class="font-regular-body-large">
        Die auf unserer (u.U. durch Verlinkungen auf dritten Websites erreichte)
        Plattform
        <a
          class="font-color-black"
          href="https://wissen.institute"
          target="_blank">
          www.wissen.institute
        </a>
        angebotenen Kurse werden von der Institut Wissen gemeinnützige UG
        (haftungsbeschränkt), Geschäftsführerinnen Sabrina Heizmann und Vanessa
        Diel, Kreuzstraße 7, 77716 Hofstetten, Telefon: +49 6438 92 79 079,
        E-Mail:
        <a href="mailto:kontakt&#64;wissen.institute">
          kontakt&#64;wissen.institute
        </a>
        (nachfolgend <strong>„Veranstalterin“</strong>,
        <strong>„wir“</strong> oder <strong>„uns“</strong>) veranstaltet, mit
        Ausnahme des Vorbereitungskurses zur Erlangung der sektoralen
        Heilpraktiker-Erlaubnis. Diese Allgemeinen Geschäftsbedingungen (im
        Folgenden „<strong>AGB</strong>“) gelten für sämtliche Verträge zwischen
        uns, und Personen, die für sich und/oder eine dritte Person einen Platz
        für die Teilnahme an einem der dort angebotenen Kurse buchen
        (nachfolgend <strong>„Kund*innen“</strong>).
      </div>
    </div>
    <div class="flex-r gap-8">
      <span class="title-level-3"> 1.2. </span>
      <div class="font-regular-body-large">
        Die AGB gelten, soweit nicht anders ausdrücklich angegeben, unabhängig
        davon, ob Kund:innen Verbraucher, Unternehmer oder Kaufmann sind. Bei
        Regelungen, die für Verbraucher und Unternehmer unterschiedlich sind,
        wird im Text zwischen Verbrauchern (§ 13 BGB) und Unternehmern (§ 14
        BGB) unterschieden. Verbraucher im Sinne dieser AGB sind natürliche
        Personen, die Verträge zu einem Zweck abschließen, der überwiegend weder
        ihrer gewerblichen noch ihrer selbstständigen beruflichen Tätigkeit
        zugerechnet werden kann. Unternehmer im Sinne dieser AGB sind natürliche
        oder juristische Personen oder rechtsfähige Personengesellschaften, die
        bei Vertragsschluss mit uns in Ausübung ihrer gewerblichen oder
        selbstständigen beruflichen Tätigkeit handeln.
      </div>
    </div>
    <div class="flex-r gap-8">
      <span class="title-level-3"> 1.3. </span>
      <div class="font-regular-body-large">
        Die AGB gelten, soweit nicht anders ausdrücklich angegeben, für
        sämtliche von uns angebotenen Kurse. Für unsere „zertifizierten Kurse“
        können ergänzende oder abweichende Bestimmungen gelten. Unsere
        zertifizierten Kurse sind von der staatlichen Zentralstelle für
        Fernunterricht (ZFU) zugelassen und in der Kursbezeichnung mit dem
        Zusatz „zertifiziert“ gekennzeichnet. Soweit besondere Regelungen
        ausschließlich für zertifizierte Kurse oder ausschließlich für
        nicht-zertifizierte Kurse gelten, wird im Folgenden ausdrücklich
        zwischen „zertifizierten Kursen“ und „nicht-zertifizierten Kursen“
        unterschieden.
      </div>
    </div>
    <div class="flex-r gap-8">
      <span class="title-level-3"> 1.4. </span>
      <div class="font-regular-body-large">
        Abweichende Vertragsbedingungen von Kund:innen finden selbst dann keine
        Anwendung, wenn wir deren Einbeziehung nicht ausdrücklich widersprechen.
      </div>
    </div>
    <span class="title-level-2"> 2. Vertragsschluss </span>
    <div class="flex-r gap-8">
      <span class="title-level-3"> 2.1. </span>
      <div class="font-regular-body-large">
        Um über die Plattform einen Kurs buchen zu können, müssen Kund:innen
        zunächst ein Nutzerprofil unter Verwendung einer gültigen E-Mail-Adresse
        und durch Festlegung eines sicheren Passwortes anlegen.
      </div>
    </div>
    <div class="flex-r gap-8">
      <span class="title-level-3"> 2.2. </span>
      <div class="font-regular-body-large">
        Anschließend können Kund:innen über die Plattform einen oder mehrere der
        angebotenen Kurse auswählen. Danach sind die abgefragten Daten im
        Online-Anmeldeformular vollständig und korrekt anzugeben und sodann kann
        mit Bestätigung der Kenntnisnahme dieser AGB über den Button
        „zahlungspflichtig buchen“ ein verbindliches Angebot gegenüber der
        Veranstalterin zur Buchung des/der Kurse/s abgegeben werden. Vor dem
        Abschicken der Buchung können Kund:innen die angegebenen Informationen
        jederzeit einsehen und ändern oder über den Button „Abbrechen“,
        alternativ durch Schließen des Browserfensters, den Buchungsvorgang ganz
        abbrechen. Die Veranstalterin bestätigt im Anschluss den Eingang des
        Vertragsangebotes durch eine automatische E-Mail (Empfangsbestätigung),
        in welcher die Buchung nochmals aufgeführt wird. In einer solchen E-Mail
        liegt noch keine verbindliche Annahme der Buchung, es sei denn, darin
        wird neben der Bestätigung des Zugangs zugleich die Annahme erklärt
        (Buchungsbestätigung). Ein Vertrag mit der Veranstalterin kommt erst
        dann zustande, wenn wir die Buchung durch eine entsprechende E-Mail
        annehmen. Diese E-Mail enthält den Vertragstext (bestehend aus der
        Buchung, den AGB und der Buchungsbestätigung) und fungiert damit auch
        als Vertragsbestätigung.
      </div>
    </div>
    <div class="flex-r gap-8">
      <span class="title-level-3"> 2.3. </span>
      <div class="font-regular-body-large">
        Der Vertragsschluss erfolgt in deutscher Sprache.
      </div>
    </div>
    <span class="title-level-2"> 3. Preise, Zahlungsbedingungen </span>
    <div class="flex-r gap-8">
      <span class="title-level-3"> 3.1. </span>
      <div class="font-regular-body-large">
        Es gelten die online auf der Plattform und im Buchungsprozess jeweils
        genannten Teilnahmegebühren und Zahlungsbedingungen. Unsere Leistungen
        sind von der Umsatzsteuer befreit. Sollte die Befreiung entfallen,
        verstehen sich alle Preise zzgl. der geltenden Umsatzsteuer.
      </div>
    </div>
    <div class="flex-r gap-8">
      <span class="title-level-3"> 3.2. </span>
      <div class="font-regular-body-large">
        Damit die Veranstalterin die Zahlung der entsprechenden Buchung zuordnen
        kann, ist unabhängig von der Zahlungsart, bei Zahlung die Angabe der
        Rechnungsnummer im Verwendungszweck zwingend erforderlich. Ist eine
        Zahlung der Teilnahmegebühr per Rechnung erwünscht, ist die Zahlung
        innerhalb von vierzehn (14) Tagen ab Rechnungseingang durch Überweisung
        an die auf der Rechnung enthaltenen Zahlungsinformationen unter Angabe
        der mitgeteilten Rechnungsnummer zur Zahlung fällig.
      </div>
    </div>
    <span class="title-level-2">
      4. Leistungsumfang, personalisierte Teilnahme
    </span>
    <div class="flex-r gap-8">
      <span class="title-level-3"> 4.1. </span>
      <div class="font-regular-body-large">
        Die Teilnahmegebühr berechtigt ausschließlich die jeweils als
        „Teilnehmende“ bezeichneten Personen zur Teilnahme am jeweiligen Kurs
        und zum Zugriff auf die in der jeweiligen Kursbeschreibung beschriebene
        und im Rahmen des Kurses zur Verfügung gestellten Kursunterlagen.
        Teilnehmende erhalten nach Abschluss des Kurses eine entsprechende
        Teilnahmebescheinigung per Mail. Bei Nichterscheinen erlischt der
        Anspruch auf Ausstellung einer Teilnahmebescheinigung.
      </div>
    </div>
    <div class="flex-r gap-8">
      <span class="title-level-3"> 4.2. </span>
      <div class="font-regular-body-large">
        <p class="mb-12">(1) Nicht-zertifizierte Kurse</p>
        <p class="mb-16">
          Bei der Buchung eines nicht-zertifizierten Kurses erhalten Sie über
          unsere Plattform Zugriff auf die entsprechenden online durchgeführten
          Live-Seminare. Die in den Live-Seminaren vermittelten Inhalte sind den
          jeweiligen Kurs-Beschreibungen zu entnehmen. Kund:innen haben keinen
          Anspruch auf individuelle Betreuung oder Lernerfolgskontrollen. Unsere
          nicht-zertifizierten Kurse bereiten weder auf staatliche Abschlüsse
          irgendeiner Art noch auf den Erwerb von Zertifikaten oder den
          Abschluss bzw. das Bestehen einer Prüfung vor. Eine
          Teilnahmebestätigung kann ausgestellt werden; diese stellt keinen
          Leistungsnachweis oder Prüfungserfolg dar.
        </p>
        <p class="mb-12">(2) Zertifizierte Kurse</p>
        <p>
          Bei der Buchung eines unserer zertifizierten Kurse erhalten Sie über
          Ihr Nutzerprofil Zugriff auf die entsprechenden Kursinhalte.
          Grundsätzlich umfasst das Kursangebot die entsprechenden online
          durchgeführten Live-Seminare, zusammengeschnittene Aufzeichnungen der
          Live-Seminare zum Online-Wiederaufruf, Dokumente zur eigenen Reflexion
          sowie Durchführung, Überprüfung und Feedback von
          Lernerfolgskontrollen. Weitere Informationen, insbesondere über die
          Vertragslaufzeit, die Art und Geltung des Kursabschlusses, Ort, Dauer
          und Häufigkeit des begleitenden Unterrichts sowie Angaben über
          inbegriffene Lehrmaterialien und die vereinbarten Zeitabstände für die
          Lieferung von Lehrmaterialien, können der vor Abschluss des Vertrags
          angezeigten Kursbeschreibung entnommen werden. Die Kursmaterialien
          werden den Teilnehmenden digital zur Verfügung gestellt.
        </p>
      </div>
    </div>
    <div class="flex-r gap-8">
      <span class="title-level-3"> 4.3. </span>
      <div class="font-regular-body-large">
        Soweit unsere zertifizierten Kurse auf eine staatliche oder sonstige
        Prüfung vorbereiten, informieren wir Sie in der Kursbeschreibung über
        die jeweils geltenden Zulassungsvoraussetzungen für die Prüfung.
      </div>
    </div>
    <span class="title-level-2"> 5. Umbuchung </span>

    <div class="font-regular-body-large">
      Die Personalisierung der Teilnahmeberechtigung ist erforderlich, damit die
      Veranstalterin personalisierte Teilnahmebestätigungen ausstellen kann. Für
      den Fall, dass der Teilnehmende nicht am Kurs teilnehmen kann, bietet die
      Veranstalterin jedoch gegen eine Bearbeitungsgebühr in Höhe von EUR 15,00
      bis 2 Werktage vor Beginn des gebuchten Kurses, die Möglichkeit zur
      Umbuchung für eine benannte Dritte Person. Die Umbuchung hat
      ausschließlich per E-Mail an
      <a href="mailto:kontakt&#64;wissen.institute">
        kontakt&#64;wissen.institute
      </a>
      zu erfolgen. Benennt der:die Kund:in einen) Ersatzteilnehmenden, ohne dass
      eine Vertragsübernahme stattfindet, bleibt der Vertrag mit dem:der Kund:in
      bestehen.
    </div>
    <span class="title-level-2"> 6. Vertragsbeendigung </span>
    <div class="flex-r gap-8">
      <span class="title-level-3"> 6.1.</span>
      <div class="flex-c">
        <div class="title-level-3 mb-8">
          Kündigung von Fernunterrichtsverträgen
        </div>
        <div class="font-regular-body-large">
          <p>
            (1) Für Verträge zur Teilnahme an unseren zertifizierten Kursen
            („Fernunterrichtsvertrag“) gelten die gesetzlichen Kündigungsrechte
            nach § 5 FernUSG. Das Recht beider Parteien zur Kündigung aus
            wichtigem Grund bleibt unberührt. Ein wichtiger Grund liegt vor,
            wenn dem Kündigenden unter Berücksichtigung aller Umstände des
            Einzelfalls und unter Abwägung der Interessen beider Parteien die
            Fortsetzung des Vertragsverhältnisses nicht zugemutet werden kann.
            Dies liegt insbesondere vor, wenn der Teilnehmer mit einer Zahlung
            erheblich in Verzug ist und die Zahlung auch nach Mahnung und
            fruchtlosem Ablauf einer angemessenen Nachfrist nicht leistet. Die
            Kündigung bedarf der Textform.
          </p>
          <p>
            (2) Bei Fernunterrichtsverträgen mit einer vorgesehenen Laufzeit von
            weniger als 6 Monaten bietet der Veranstalter Teilnehmenden nach
            Ablauf der Widerrufsfrist zusätzlich zu den gesetzlichen Rechten des
            Teilnehmenden nach dem FernUSG die Möglichkeit, den gebuchten Kurs
            bis 15 Tage vor Kursbeginn schriftlich (E-Mail an
            <a href="mailto:kontakt&#64;wissen.institute">
              kontakt&#64;wissen.institute
            </a>
            genügt) zu stornieren. Mit Zugang der Stornierung endet der Vertrag
            mit Wirkung für die Zukunft. Bereits geleistete Vergütungen werden
            erstattet. Teilnehmende haben eine Bearbeitungsgebühr in Höhe von
            EUR 29,00 zu zahlen und entstandene Kosten für bereits übersendete
            Materialien zu erstatten.
          </p>
        </div>
      </div>
    </div>
    <div class="flex-r gap-8">
      <span class="title-level-3"> 6.2. </span>
      <div class="font-regular-body-large">
        <p class="mb-12">
          Nicht-zertifizierte-Kurse können Kund:innen nach Ablauf der
          Widerrufsfrist jederzeit stornieren. Stornierungen haben
          ausschließlich per E-Mail an
          <a href="mailto:kontakt&#64;wissen.institute">
            kontakt&#64;wissen.institute
          </a>
          zu erfolgen.
        </p>
        <p>
          (1) Bei Stornierung entstehen Stornierungsgebühren, die sich wie folgt
          staffeln:
        </p>
        <ul>
          <li>
            Bei Stornierung einer Buchung bis 28 Tage vor Beginn des gebuchten
            Kurses fallen EUR 29,00 Bearbeitungsgebühr an.
          </li>
          <li>
            Bei Stornierung einer Buchung 27 bis 8 Tage vor Beginn des gebuchten
            Kurses wird eine Stornierungsgebühr in Höhe von 50 % der
            Teilnahmegebühr fällig, mindestens jedoch EUR 29,00.
          </li>
          <li>
            Bei Stornierung einer Buchung 7 Tage oder weniger vor Kursbeginn,
            oder bei Nichterscheinen, wird eine Stornierungsgebühr in Höhe von
            100 % der Teilnahmegebühr fällig.
          </li>
        </ul>
        <p class="mb-12">
          (2) Kund:innen bleibt der Nachweis vorbehalten, dass kein Schaden oder
          ein wesentlich geringerer Schaden als in Höhe der vorgenannten
          Pauschalen entstanden ist.
        </p>
        <p>
          (3) Das Recht beider Parteien zur Kündigung aus wichtigem Grund bleibt
          unberührt. Ein wichtiger Grund liegt vor, wenn der Teilnehmer mit
          einer Zahlung erheblich in Verzug ist und die Zahlung auch nach
          Mahnung und fruchtlosem Ablauf einer angemessenen Nachfrist nicht
          leistet. Die Kündigung bedarf der Textform.
        </p>
      </div>
    </div>
    <div class="flex-r gap-8">
      <span class="title-level-3"> 6.3. </span>
      <div class="font-regular-body-large">
        <p class="mb-12">
          Wir sind zum jederzeitigen Rücktritt vom Vertrag zur Teilnahme an
          nicht-zertifizierten Kursen berechtigt, wenn
        </p>
        <p class="mb-12">
          (1) die Durchführung der Dienstleistung aus Gründen, die wir nicht zu
          vertreten haben, unmöglich wird oder unzumutbar beeinträchtigt ist.
          Dies gilt insbesondere bei Eintritt nicht vorhersehbarer
          Durchführungshindernisse, wie insbesondere dem kurzfristigen Ausfall
          des Kursleitenden ohne zumutbarer Ersatzmöglichkeit, behördlichen
          Maßnahmen, technischen Ausfällen oder sonstigen Fällen höherer Gewalt.
        </p>
        <p class="mb-12">
          (2) Kund:innen trotz Mahnung und angemessener Fristsetzung notwendige
          Mitwirkungspflichten nicht erfüllen und die Erbringung der
          vereinbarten Leistungen dadurch dauerhaft wesentlich erschwert oder
          unmöglich wird. Dies gilt insbesondere für den Fall, dass Kund:innen
          die notwendige Personalisierung der Zahlung und Teilnahme durch
          unterlassene Angabe der Rechnungsnummer bzw. Angabe einer falschen
          Rechnungsnummer verhindern.
        </p>
        <p>
          (3) Im Falle des Rücktritts erstatten wir Kund:innen bereits
          geleistete Vergütungen, soweit sie auf noch nicht erbrachte Leistungen
          entfallen. Weitere Ansprüche bestehen nicht.
        </p>
      </div>
    </div>
    <div class="flex-r gap-8">
      <span class="title-level-3"> 6.4. </span>
      <div class="font-regular-body-large">
        Kund:innen, die unsere zertifizierten Kurse buchen sowie Kund:innen, die
        unsere Kurse als Verbraucher:innen buchen, haben das Recht, binnen
        vierzehn Tagen nach Abschluss der Buchung ohne Angabe von Gründen diesen
        Vertrag zu widerrufen. Im Übrigen gelten für das Widerrufsrecht die in
        folgender Widerrufsbelehrung wiedergegebenen Regelungen:
      </div>
    </div>
    <span class="title-level-2"> 7. Nutzungsrechte an Seminarunterlagen</span>
    <div class="font-regular-body-large">
      Kund:innen, die unsere zertifizierten Kurse buchen sowie Kund:innen, die
      unsere Kurse als Verbraucher:innen buchen, haben das Recht, binnen
      vierzehn Tagen nach Abschluss der Buchung ohne Angabe von Gründen diesen
      Vertrag zu widerrufen. Im Übrigen gelten für das Widerrufsrecht die in
      folgender Widerrufsbelehrung wiedergegebenen Regelungen:
    </div>
    <div class="font-regular-body-large widerrufsbelehrung">
      <h3 class="text-center">Widerrufsbelehrung</h3>
      <h4>Widerrufsrecht</h4>
      Sie haben das Recht, diesen Vertrag binnen vierzehn Tagen ab
      Vertragsschluss ohne Angabe von Gründen zu widerrufen. Um Ihr
      Widerrufsrecht auszuüben, müssen Sie uns, Institut Wissen gemeinnützige UG
      (haftungsbeschränkt), Geschäftsführerinnen Sabrina Heizmann und Vanessa
      Diel, Kreuzstraße 7, 77716 Hofstetten, Telefon: +49 6438 – 92 79 079,
      E-Mail: <a href="mailto:kontakt&#64;wissen.institute">
        kontakt&#64;wissen.institute </a
      > mittels einer eindeutigen Erklärung (z. B. ein mit der Post versandter
      Brief, Telefax oder E-Mail) über Ihren Entschluss, diesen Vertrag zu
      widerrufen, informieren. Sie können dafür das beigefügte
      <a href="assets/Muster-Widerrufungsformular.pdf" target="_blank">
        Muster-Widerrufsformular
      </a>
      verwenden, das jedoch nicht vorgeschrieben ist. Zur Wahrung der
      Widerrufsfrist reicht es aus, dass Sie die Mitteilung über die Ausübung
      des Widerrufsrechts vor Ablauf der Widerrufsfrist absenden.
      <h4 class="">Folgen des Widerrufs</h4>
      Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die
      wir von Ihnen erhalten haben, einschließlich etwaiger Lieferkosten für
      Materialien (mit Ausnahme der zusätzlichen Kosten, die sich daraus
      ergeben, dass Sie eine andere Art der Lieferung als die von uns
      angebotene, günstigste Standardlieferung gewählt haben), unverzüglich und
      spätestens binnen vierzehn Tagen ab dem Tag zurückzuzahlen, an dem die
      Mitteilung über Ihren Widerruf dieses Vertrags bei uns eingegangen ist.
      Für diese Rückzahlung verwenden wir dasselbe Zahlungsmittel, das Sie bei
      der ursprünglichen Transaktion eingesetzt haben, es sei denn, mit Ihnen
      wurde ausdrücklich etwas anderes vereinbart; in keinem Fall werden Ihnen
      wegen dieser Rückzahlung Entgelte berechnet. Sie haben etwaige übersendete
      Materialien unverzüglich und in jedem Fall spätestens binnen vierzehn
      Tagen ab dem Tag, an dem Sie uns über den Widerruf dieses Vertrages
      unterrichten, an uns zurückzusenden oder zu übergeben. Die Frist ist
      gewahrt, wenn Sie die Materialien vor Ablauf der Frist von vierzehn Tagen
      absenden. Sie tragen die unmittelbaren Kosten der Rücksendung der
      Materialien. Die Kosten werden auf etwa 6,19 EUR geschätzt. Haben Sie
      verlangt, dass die Dienstleistung während der Widerrufsfrist beginnen
      soll, so haben Sie uns einen angemessenen Betrag zu zahlen, der dem Anteil
      der bis zu dem Zeitpunkt, zu dem Sie uns von der Ausübung des
      Widerrufsrechts hinsichtlich dieses Vertrags unterrichten, bereits
      erbrachten Dienstleistungen im Vergleich zum Gesamtumfang der im Vertrag
      vorgesehenen Dienstleistungen entspricht. <br />
      – Ende der Widerrufsbelehrung –
    </div>
    <span class="title-level-2"> 8. Nutzungsrechte an Kurs-Unterlagen</span>
    <div class="font-regular-body-large">
      Soweit nicht anders ausdrücklich vereinbart, dürfen etwaig zur Verfügung
      gestellte Kurs-Unterlagen, Aufzeichnungen der Seminare und sonstige auf
      der Plattform veröffentlichten Dokumente, Bilder, Videos und Texte von den
      Teilnehmenden nur zum Eigenstudium, einschließlich Vor- und Nachbereitung
      des jeweiligen Kurses verwendet werden. Sie dürfen insbesondere nicht –
      auch nicht in Auszügen – vervielfältigt, übersetzt, elektronisch
      weiterverarbeitet, verbreitet und/oder öffentlich wiedergegeben werden.
      Soweit Kund:innen einen Kurs für Dritte buchen, sind sie verpflichtet, die
      Teilnehmenden entsprechend dieser Ziffer zu verpflichten.
    </div>

    <span class="title-level-2"> 9. Änderungsvorbehalt</span>
    <div class="flex-r gap-8">
      <span class="title-level-3"> 9.1. </span>
      <div class="font-regular-body-large">
        Die Veranstalterin behält sich in Ausnahmefällen vor, angekündigte
        Kursleitende durch andere gleich qualifizierte Kursleitende zu ersetzen
        und notwendige Änderungen des Veranstaltungsprogrammes (Inhalt, Termin,
        Durchführungsort) auch kurzfristig vorzunehmen, soweit der
        Gesamtcharakter der Veranstaltung erhalten bleibt und die Änderung unter
        Berücksichtigung der Belange der Teilnehmenden zumutbar ist.
      </div>
    </div>
    <div class="flex-r gap-8">
      <span class="title-level-3"> 9.2. </span>
      <div class="font-regular-body-large">
        Die Veranstalterin wird bei eventuell auftretenden Leistungsstörungen
        oder Durchführungshindernissen alles Zumutbare unternehmen, um zu einer
        Behebung oder Begrenzung der Störung beizutragen.
      </div>
    </div>

    <span class="title-level-2"> 10. Haftung</span>
    <div class="flex-r gap-8">
      <span class="title-level-3"> 10.1. </span>
      <div class="font-regular-body-large">
        Die Veranstalterin haftet unbeschränkt bei Vorsatz und grober
        Fahrlässigkeit, aufgrund einer Verletzung des Lebens, des Körpers oder
        der Gesundheit, nach den Vorschriften des Produkthaftungsgesetzes und im
        Umfang einer etwaig von der Veranstalterin übernommenen Garantie.
      </div>
    </div>
    <div class="flex-r gap-8">
      <span class="title-level-3"> 10.2. </span>
      <div class="font-regular-body-large">
        Bei leicht fahrlässiger Verletzung einer Pflicht, die wesentlich für die
        Erreichung des Vertragszwecks ist, da sie die ordnungsgemäße
        Durchführung des Vertrages erst ermöglicht und auf deren Erfüllung die
        andere Partei deshalb vertraut und vertrauen darf (Kardinalpflicht), ist
        die Haftung der Veranstalterin der Höhe nach begrenzt auf den Schaden,
        der nach der Art des hier in Rede stehenden Geschäfts vorhersehbar und
        typisch ist.
      </div>
    </div>
    <div class="flex-r gap-8">
      <span class="title-level-3"> 10.3. </span>
      <div>
        Die soeben genannten Haftungsbeschränkungen gelten auch zugunsten
        gesetzlicher Vertreter und Erfüllungsgehilfen der Veranstalterin, wenn
        Ansprüche direkt gegen diese geltend gemacht werden.
      </div>
    </div>
    <span class="title-level-2"> 11. Datenschutz</span>
    <div class="font-regular-body-large">
      Die Datenschutzbestimmungen und die Kontaktdaten des
      Datenschutzbeauftragten des Veranstalters können unter
      <a href="https://wissen.institute/privacy-policy" target="_blank">
        https://wissen.institute/privacy-policy
      </a>
      abgerufen werden.
    </div>
    <span class="title-level-2"> 12. Sonstiges</span>
    <div class="flex-r gap-8">
      <span class="title-level-3"> 12.1. </span>
      <div class="font-regular-body-large">
        <strong>Vertragstext.</strong> Sie können die aktuelle Version dieser
        AGB jederzeit herunterladen und aufbewahren. Zu Beweiszwecken speichern
        wir auch den jeweiligen Vertragstext, welchen wir auf Anfrage
        übermitteln können.
      </div>
    </div>
    <div class="flex-r gap-8">
      <span class="title-level-3"> 12.2. </span>
      <div class="font-regular-body-large">
        <strong>Salvatorische Klausel.</strong> Sollte eine Bestimmung dieses
        Vertrages ganz oder teilweise unwirksam sein oder werden, so wird
        hierdurch die Wirksamkeit der übrigen Bestimmungen nicht berührt.
        Anstelle der unwirksamen Bestimmung gilt diejenige wirksame Bestimmung
        als vereinbart, die dem Sinn und Zweck der unwirksamen Bestimmung am
        nächsten kommt.
      </div>
    </div>
    <div class="flex-r gap-8">
      <span class="title-level-3"> 12.3. </span>
      <div class="font-regular-body-large">
        <strong>Anwendbares Recht.</strong> Es gilt das Recht der Bundesrepublik
        Deutschland unter Ausschluss des UN-Kaufrechts. Wenn Sie einen Kurs als
        Verbraucher buchen und zum Zeitpunkt Ihrer Buchung Ihren gewöhnlichen
        Aufenthalt in einem anderen Land haben, bleibt die Anwendung zwingender
        Rechtsvorschriften dieses Landes von der in Satz 1 getroffenen
        Rechtswahl unberührt.
      </div>
    </div>
    <div class="flex-r gap-8">
      <span class="title-level-3"> 12.4. </span>
      <div class="font-regular-body-large">
        <strong>Gerichtsstand.</strong> Wenn Sie Kaufmann sind und Ihren Sitz
        zum Zeitpunkt der Buchung in Deutschland haben, ist ausschließlicher
        Gerichtsstand Limburg. Bei Streitigkeiten im Zusammenhang mit unseren
        zertifizierten Kursen ist Gerichtsstand der Wohnsitz des/der Kund:in. Im
        Übrigen gelten für die örtliche und die internationale Zuständigkeit die
        anwendbaren gesetzlichen Bestimmungen.
      </div>
    </div>
    <div class="flex-r gap-8">
      <span class="title-level-3"> 12.5. </span>
      <div class="font-regular-body-large">
        <strong>Streitbeilegung.</strong> Zur Teilnahme an einem
        Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle sind
        wir weder verpflichtet noch bereit.
      </div>
    </div>
    <div class="flex-r gap-8 align-center">
      <span class="title-level-3"> 12.6. </span>
      <div class="font-regular-body-large flex-r gap-8 align-center flex-wrap">
        Wer es bis zum Ende geschafft hat, darf mit dem Code
        <div class="promo-code">
          ICHLESEAGB5
          <div (click)="copyToClipboard('ICHLESEAGB5')" class="copy-button">
            <i class="fa-regular fa-copy"></i>
          </div>
        </div>
        5€ Rabatt auf das nächste Seminar sparen.
      </div>
    </div>
  </div>
  <div class="flex-r gap-8 align-center">
    <span class="font-regular-body-large">Stand: Mai 2026</span>
  </div>
</div>
